import React from 'react';
import { string } from 'prop-types';

import ExternalLink from '../ExternalLink';

import s from './Help.css';

const helpIcon =
  <svg width="14" height="23" viewBox="0 0 14 23">
    <path d="M5.205 19.308c.33-.312.725-.468 1.19-.468.464 0 .855.156 1.172.468.317.312.476.683.476 1.113V21c0 .453-.16.83-.476 1.13-.317.302-.708.452-1.172.452-.465 0-.86-.15-1.19-.45-.328-.303-.493-.68-.493-1.13v-.58c0-.43.165-.802.493-1.114zM11.44 1.984c1.406 1.323 2.108 2.85 2.108 4.58 0 1.732-.52 3.205-1.563 4.42-1.042 1.216-2.356 2.006-3.942 2.372v2.097c0 .45-.16.828-.476 1.13-.317.3-.708.45-1.172.45-.465 0-.86-.15-1.19-.45-.328-.302-.493-.68-.493-1.13v-3.355c0-.022.006-.033.017-.033.01 0 .01-.01 0-.032-.013-.02-.02-.043-.02-.064 0-.41.166-.777.494-1.1.33-.322.72-.483 1.173-.483 1.065 0 1.976-.355 2.735-1.065.76-.71 1.14-1.564 1.14-2.564 0-1.002-.38-1.85-1.14-2.55-.76-.7-1.67-1.05-2.735-1.05-1.45 0-2.538.593-3.263 1.776-.25.387-.595.634-1.036.742-.443.107-.868.054-1.276-.162C.42 5.28.17 4.956.057 4.55c-.114-.41-.057-.81.17-1.196.61-1.01 1.467-1.822 2.565-2.434C3.892.305 5.086 0 6.378 0c1.97 0 3.66.66 5.063 1.984z" fillRule="evenodd"/>
  </svg>;

// Let's leave this as its own component as I can see it evolving into an entire LandingPage
const Help = ({ ...props }) =>
  <ExternalLink
    className={s.component}
    id="portalHelpUrl"
    icon={helpIcon}
    label=""
    title="Help Url"
    url={props.data}
  />;

Help.propTypes = {
  data: string.isRequired,
};

export default Help;



// WEBPACK FOOTER //
// ./src/components/Help/Help.js